import React from 'react';
import { Facebook, Instagram } from 'lucide-react';
import { Logo } from './Logo';
export function Footer() {
  return <footer className="bg-brand-dark text-white pt-16 pb-8" data-id="element-88">
      <div className="container mx-auto px-6 md:px-8" data-id="element-89">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-16 text-center md:text-left" data-id="element-90">
          {/* Col 1: Brand */}
          <div className="flex flex-col items-center md:items-start" data-id="element-91">
            <Logo variant="light" className="mb-4" data-id="element-92" />
            <p className="text-brand-teal font-medium mb-6" data-id="element-93">
              Relax, We'll Handle It!
            </p>
            <div className="flex items-center gap-4" data-id="element-94">
              <a href="https://www.facebook.com/profile.php?id=61574761225288" className="text-white/60 hover:text-white transition-colors" aria-label="Facebook" data-id="element-95">
                <Facebook size={20} data-id="element-96" />
              </a>
              <a href="https://www.instagram.com/bonsaipoolcarellc/" className="text-white/60 hover:text-white transition-colors" aria-label="Instagram" data-id="element-97">
                <Instagram size={20} data-id="element-98" />
              </a>
              <a href="https://www.tiktok.com/@bonsai.poolcare" className="text-white/60 hover:text-white transition-colors" aria-label="TikTok" data-id="element-99">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg" data-id="element-100">
                  <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5 20.1a6.34 6.34 0 0 0 10.86-4.43v-7a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1-.1z" data-id="element-101" />
                </svg>
              </a>
            </div>
          </div>

          {/* Col 2: Navigation */}
          <div className="flex flex-col items-center md:items-start" data-id="element-102">
            <h4 className="font-heading font-bold text-lg mb-6" data-id="element-103">Navigation</h4>
            <ul className="space-y-3" data-id="element-104">
              <li data-id="element-105">
                <a href="#" className="text-white/70 hover:text-white transition-colors" data-id="element-106">
                  Home
                </a>
              </li>
              <li data-id="element-107">
                <a href="#about" className="text-white/70 hover:text-white transition-colors" data-id="element-108">
                  About Us
                </a>
              </li>
              <li data-id="element-109">
                <a href="#services" className="text-white/70 hover:text-white transition-colors" data-id="element-110">
                  Services
                </a>
              </li>
              <li data-id="element-111">
                <a href="#faq" className="text-white/70 hover:text-white transition-colors" data-id="element-112">
                  FAQ
                </a>
              </li>
              <li data-id="element-113">
                <a href="#contact" className="text-white/70 hover:text-white transition-colors" data-id="element-114">
                  Contact
                </a>
              </li>
            </ul>
          </div>

          {/* Col 3: Contact */}
          <div className="flex flex-col items-center md:items-start" data-id="element-115">
            <h4 className="font-heading font-bold text-lg mb-6" data-id="element-116">
              Contact Info
            </h4>
            <ul className="space-y-3 text-white/70" data-id="element-117">
              <li data-id="element-118">
                <a href="tel:+14804012244" className="hover:text-white transition-colors" data-id="element-119">
                  (480) 401-2244
                </a>
              </li>
              <li data-id="element-120">
                <a href="mailto:service@bonsaipoolcare.com" className="hover:text-white transition-colors" data-id="element-121">
                  service@bonsaipoolcare.com
                </a>
              </li>
              <li className="pt-2" data-id="element-122">Scottsdale, AZ</li>
              <li data-id="element-123">Northeast Valley</li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-white/10 pt-8 flex flex-col md:flex-row justify-between items-center gap-4 text-sm text-white/50 text-center md:text-left" data-id="element-124">
          <p data-id="element-125">© 2025 Bonsai Pool Care LLC. All rights reserved.</p>
          <p data-id="element-126">Managed by LetLois</p>
        </div>
      </div>
    </footer>;
}